var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"embed-responsive-item",attrs:{"allow":"accelerometer","src":_vm.getYoutubeUrl(_vm.slide),"allowfullscreen":"","scrolling":"no","title":"youtube video"}})
}
var staticRenderFns = []

export { render, staticRenderFns }